import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { CircleMinus } from 'lucide-react';
import { useStandaloneFieldSx } from '../shared';
import CenterModal from './CenterModal';
import { useSangria } from './useCashActions';

// Sangria — modal central (§5.6), ícone em tom danger. 2 campos obrigatórios
// ("Valor da sangria (R$)" + "Motivo"), mesmo padrão de
// `prototipo-lista-caixas.html`/`prototipo-painel-caixa.html`. Endpoint real:
// `POST /cashregister/bleeding` (`cashregister/sangria.go`), payload
// `{cash_register_id, value, reason}`.
export default function SangriaModal({ open, onClose, cashRegister, onSuccess, onError }) {
    const standaloneFieldSx = useStandaloneFieldSx();
    const { amount, reason, amountError, reasonError, saving, changeAmount, changeReason, confirm: handleConfirm } = useSangria({ open, cashRegister, onSuccess, onError });

    return (
        <CenterModal
            open={open}
            onClose={onClose}
            icon={CircleMinus}
            iconBg="error.bg"
            iconColor="error.main"
            title="Registrar Sangria"
            description={cashRegister ? `Registre uma retirada de dinheiro do terminal "${cashRegister.name}".` : ''}
            onConfirm={handleConfirm}
            confirmText="Registrar sangria"
            confirmColor="error"
            loading={saving}
        >
            <Box sx={{ mb: 2 }}>
                <TextField
                    autoFocus
                    fullWidth
                    label="Valor da sangria (R$) *"
                    value={amount}
                    onChange={(e) => changeAmount(e.target.value)}
                    error={Boolean(amountError)}
                    helperText={amountError}
                    variant="outlined"
                    sx={standaloneFieldSx}
                />
            </Box>
            <Box>
                <TextField
                    fullWidth
                    label="Motivo *"
                    value={reason}
                    onChange={(e) => changeReason(e.target.value)}
                    error={Boolean(reasonError)}
                    helperText={reasonError}
                    variant="outlined"
                    inputProps={{ maxLength: 120 }}
                    sx={standaloneFieldSx}
                />
            </Box>
        </CenterModal>
    );
}
